import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { SERVER_BASE_URL } from "../config"; // Импорт централизованного базового URL

function WorkerRegisterPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();

  const [invitation, setInvitation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  // Поля для регистрации
  const [name, setName] = useState("");
  // Покажем email read-only (берём из invitation)
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  // Подтверждение пароля
  const [confirmPassword, setConfirmPassword] = useState("");

  useEffect(() => {
    if (!token) {
      setNotFound(true);
      setLoading(false);
      return;
    }
    // Загружаем приглашение по токену, чтобы узнать, валидно ли оно
    async function loadInvitation() {
      try {
        const res = await fetch(`${SERVER_BASE_URL}/api/worker_invitations/by_token/${token}`);
        if (!res.ok) {
          setNotFound(true);
        } else {
          const data = await res.json();
          setInvitation(data);
          // Здесь заполним email из data
          setEmail(data.invitee_email);
        }
      } catch (err) {
        console.error(err);
        setNotFound(true);
      } finally {
        setLoading(false);
      }
    }
    loadInvitation();
  }, [token]);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!invitation) return;

    if (!name.trim()) {
      toast.error("Name is required");
      return;
    }
    if (!password || password.length < 6) {
      toast.error("Password must be at least 6 characters");
      return;
    }
    if (password !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    try {
      // Принимаем инвайт: POST /api/worker_invitations/accept/{invitation.id}
      const res = await fetch(
        `${SERVER_BASE_URL}/api/worker_invitations/accept/${invitation.id}`, 
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            name,
            password
          }),
        }
      );
      if (!res.ok) {
        const errData = await res.json();
        throw new Error(errData.detail || "Failed to accept invitation");
      }
      toast.success("Worker registration successful! Now you can login.");
      // Перенаправляем на /login
      navigate("/login");
    } catch (error) {
      console.error(error);
      toast.error(error.message);
    }
  }

  if (loading) {
    return <div className="flex justify-center items-center h-screen">Loading...</div>;
  }

  if (notFound || !invitation) {
    return (
      <div className="flex justify-center items-center h-screen">
        <p className="text-red-500">Invitation not found or invalid link.</p>
      </div>
    );
  }

  // Если всё ок, рендерим форму
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100">
      <div className="bg-white p-6 rounded shadow-md w-96">
        <h2 className="text-2xl font-bold mb-4">
          Worker Registration
        </h2>
        <p className="mb-4 text-gray-600">
          You are invited by organizer #{invitation.organizer_id}.
        </p>

        <form onSubmit={handleSubmit}>
          {/* Email (read-only) */}
          <div className="mb-3">
            <label className="block text-sm font-medium text-gray-700">
              Email:
            </label>
            <input
              type="email"
              className="border p-2 w-full rounded bg-gray-100"
              value={email}
              readOnly
            />
          </div>

          {/* Name (text) */}
          <div className="mb-3">
            <label className="block text-sm font-medium text-gray-700">
              Your Name:
            </label>
            <input
              type="text"
              className="border p-2 w-full rounded"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Type your name"
            />
          </div>

          {/* Password */}
          <div className="mb-3">
            <label className="block text-sm font-medium text-gray-700">
              Password (6+ chars):
            </label>
            <input
              type="password"
              className="border p-2 w-full rounded"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••"
            />
          </div>

          {/* Confirm Password */}
          <div className="mb-3">
            <label className="block text-sm font-medium text-gray-700">
              Confirm Password:
            </label>
            <input
              type="password"
              className="border p-2 w-full rounded"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="••••••"
            />
          </div>

          <button 
            type="submit"
            className="bg-green-500 text-white px-4 py-2 rounded w-full hover:bg-green-600"
          >
            Register
          </button>
        </form>
      </div>
    </div>
  );
}

export default WorkerRegisterPage;
